import Address from './address'
import Ellipsis from './ellipsis'
import Reverse from './reverse'
import Titleize from './titleize'
import Currency from './currency'

export default {
  install (Vue) {
    Vue.use(Address)
    Vue.use(Ellipsis)
    Vue.use(Reverse)
    Vue.use(Titleize)
    Vue.use(Currency)

    Vue.prototype.$filters = Vue.options.filters
  }
}
